<template>
    <div class="permission-group">
        <div v-if="showAsCategory" class="sub-entity-header">
            <button class="btn btn-light d-flex justify-content-between align-items-center w-100">
                <div class="sub-entity-title">
                    <span class="material-icons mr-2">{{ getSubEntityIcon(subEntity.key) }}</span>
                    {{ subEntity.name }}
                </div>
                <div class="d-flex align-items-center">
                    <module-toggle :is-active="isSubEntityFullySelected" :is-partial="isSubEntityPartiallySelected"
                        @toggle="toggleAll" />
                </div>
            </button>
        </div>
        <div class="permission-items" :class="{ 'no-category': !showAsCategory }">
            <permission-item v-for="permission in subEntity.actions" :key="permission._id" :permission="permission"
                :is-selected="isSelected(permission)" :is-disabled="isDisabled(permission)"
                @toggle="togglePermission" />
        </div>
    </div>
</template>

<script>
import PermissionItem from './PermissionItem.vue';
import ModuleToggle from './ModuleToggle.vue';
import { getSubEntityIcon } from './IconUtils';
import { getPermissionDescription } from '../utils/Permissions';

export default {
    name: 'SubEntityGroup',
    components: {
        PermissionItem,
        ModuleToggle
    },
    props: {
        subEntity: {
            type: Object,
            required: true
        },
        selectedPermissions: {
            type: Array,
            default: () => []
        },
        showAsCategory: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        isSubEntityFullySelected() {
            return this.subEntity.actions.every(permission =>
                this.selectedPermissions.includes(permission._id)
            );
        },
        isSubEntityPartiallySelected() {
            const selectedCount = this.subEntity.actions.filter(
                permission => this.selectedPermissions.includes(permission._id)
            ).length;
            return selectedCount > 0 && selectedCount < this.subEntity.actions.length;
        }
    },
    methods: {
        toggleAll() {
            this.$emit('toggle-all', this.subEntity.actions.map(p => p._id));
        },
        togglePermission(permission) {
            this.$emit('toggle', permission);
        },
        isSelected(permission) {
            return this.selectedPermissions.includes(permission._id);
        },
        isDisabled(permission) {
            const isViewPermission = permission.isViewPermission;
            if (isViewPermission) return false;
            
            const viewPermission = this.subEntity.actions.find(p => p.isViewPermission);
            return (viewPermission && !this.selectedPermissions.includes(viewPermission._id));
        },
        getPermissionDescription(permission) {
            try {
                return getPermissionDescription(permission);
            } catch (error) {
                return permission.split('.').pop();
            }
        },
        getSubEntityIcon
    }
}
</script>

<style lang="scss" scoped>
.permission-group {
    padding: 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
        border-bottom: none;
    }

    .sub-entity-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        border-bottom: 1px solid #f0f0f0;
        margin-bottom: 0.5rem;

        .btn-light {
            background-color: #f8f9fa;
            border: none;
            padding: 0.7rem 1.25rem;
            border-radius: 4px;
            width: 100%;
            text-align: left;

            &:hover,
            &:focus {
                background-color: #f1f3f5;
            }

            &:active {
                background-color: #e9ecef;
            }
        }

        .sub-entity-title {
            display: flex;
            align-items: center;
            font-weight: 500;
            color: #444;

            span {
                color: #5d8ffd;
                width: 20px;
                font-size: 0.9rem;
            }
        }
    }

    .permission-items {
        padding: 0.75rem 1.25rem;
        background-color: #fff;

        &.no-category {
            padding-top: 0;
            padding-bottom: 0;
        }
    }
}
</style>